import request from '@/utils/request'

// 获取医院列表
export function getHospitals(data) {
  return request({
    url: '/api/hospital/page',
    method: 'get',
    params: {...data,pcReqFlag:true},
  })
}

// 获取医院个数
export function getTotalCount() {
  return request({
    url: '/api/hospital/totalCount',
    method: 'get'
  })
}

// 获取医院详情
export function getHospitalDetail(id) {
  return request({
    url: '/api/hospital/'+id,
    method: 'get'
  })
}

// 医院ID查询医院分数
export function getHospitalCount(id) {
  return request({
    url: '/api/hospital/comment/count/'+id,
    method: 'get'
  })
}

// 医院ID查询医院科室
export function getHospitalDept(id) {
  return request({
    url: '/api/hospital/dept/'+id,
    method: 'get'
  })
}

// 医院ID查询医院评论
export function getHospitalComment(data) {
  return request({
    url: '/api/hospital/comment',
    method: 'get',
    params: data
  })
}

// 获取字典
export function getDict(data) {
  return request({
    url: '/api/dict',
    method: 'get',
    params: data
  })
}

// 获取科室详情
export function getDeptDetail(id) {
  return request({
    url: '/api/dept/'+id,
    method: 'get'
  })
}

// 获取某日可挂号医生
export function getScheduleDoctor(data) {
  return request({
    url: '/api/reserve/scheduleDoctor',
    method: 'get',
    params: data
  })
}

// 获取可挂号的医生
export function getReserveDoctor(data) {
  return request({
    url: '/api/reserve/reserveDoctor',
    method: 'get',
    params: data
  })
}

// 获取医生详情
export function getDoctorDetail(id) {
  return request({
    url: '/api/doctor/'+id,
    method: 'get'
  })
}

// 取消收藏/关注
export function cancelFavorite(data) {
  return request({
    url: '/api/favorite/cancelFavorite',
    method: 'post',
    data
  })
}

// 提交收藏/关注
export function submitFavorite(data) {
  return request({
    url: '/api/favorite/submitFavorite',
    method: 'post',
    data
  })
}

// 取消挂号预约
export function cancel(data) {
  return request({
    url: '/api/order/cancel/'+data,
    method: 'get'
  })
}

// 获取排班信息
export function getScheduleList(data) {
  return request({
    url: '/api/reserve/scheduleList',
    method: 'get',
    params: data
  })
}

// 获取医生评论列表
export function getCommentDoctor(data) {
  return request({
    url: '/api/comment/doctor',
    method: 'get',
    params: data
  })
}

// 添加评价
export function submitReservedComment(data) {
  return request({
    url: '/api/comment/submitReservedComment',
    method: 'post',
    data
  })
}
